import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=8f75ab92"
import script from "./tabs.js?vue&type=script&lang=js&external"
export * from "./tabs.js?vue&type=script&lang=js&external"
import style0 from "./tabs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports